import React, { useEffect, useState } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaArrowUp } from "react-icons/fa";


 

const EditCategory = () => {
  const [categories, setCategories] = useState([]);
  const [restaurantData, setRestaurantData] = useState({});
  const [loading, setLoading] = useState(true);

  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryPriority, setNewCategoryPriority] = useState(0);
  const MySwal = withReactContent(Swal);
    const [showButton, setShowButton] = useState(false);
  

  useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
    // Scroll to top function
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

  // Load restaurant data from local storage
 // Load restaurant data from local storage
 useEffect(() => {
    const localUserData = JSON.parse(localStorage.getItem("user"));
    if (localUserData) {
      setRestaurantData(localUserData);
    }else{
      window.location.href = "/login";
    }
  }, []);


  const fetchCategories = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/menu-categories?restaurantId=${restaurantData.restaurantId}`
      );
      setCategories(response?.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching categories:', error);
        setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (restaurantData.restaurantId) {
      fetchCategories();
    }
  }, [restaurantData.restaurantId]);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post("/api/menu-categories", {
        name: newCategoryName,
        priority: newCategoryPriority,
        restaurantId: restaurantData.restaurantId,
      });
      setNewCategoryName("");
      setNewCategoryPriority(0);
      fetchCategories(); // refresh categories list
    } catch (error) {
      console.error("Error adding category:", error);
    }
  };

  const ChangeCategoryVisibility = async (categoryId, isVisible) => { 
    try { 
      const response = await axiosInstance.put(
        `/api/menu-categories/change-visibility/${categoryId}`,
        { isVisible: !isVisible } 
        );
        if (response.status === 200) {
            setCategories((prevCategories) =>
                prevCategories.map((cat) =>
                cat._id === categoryId
                    ? { ...cat, isVisible: !isVisible }
                    : cat
                )
            );
            }
    } catch (error) {
      console.error("Error changing category visibility:", error); 
    }
  }

  const DeleteCategory = async(categoryId) => {

    MySwal.fire({
        icon: "error",
        title: "Are you sure you want to delete this food category",
        text: "Please note that all the menu items under this food category will be also deleted!!.",
        showCancelButton: true,
        confirmButtonText: "Yes delete this category",
        cancelButtonText: "Close",
      }).then(  (result) => {
        if (result.isConfirmed) {
          try {
            const response =  axiosInstance.delete(`/api/menu-categories/${categoryId}`);
            if (response.status === 200) {
              setCategories((prevCategories) =>
                prevCategories.filter((cat) => cat._id !== categoryId)
              );
              MySwal.fire({
                icon: "success",
                title: "Category Deleted",
                text: "The category has been successfully deleted.",
              });
            }

            setCategories((prevCategories) =>
              prevCategories.filter((cat) => cat._id !== categoryId)
            );
          } catch (error) {
            console.error("Error deleting category:", error);
            MySwal.fire({
              icon: "error",
              title: "Error",
              text: "There was an error deleting the category. Please try again.",
            });
          }
        }
      });
  }

  const handleCategoryChange = (categoryId, field, value) => {
    setCategories((prevCategories) =>
      prevCategories.map((cat) =>
        cat._id === categoryId ? { ...cat, [field]: value } : cat
      )
    );
  }
  const SaveCategoryChanges = async (category) => {
    try {
      const response = await axiosInstance.put(
        `/api/menu-categories/${category._id}`,
        category
      );
      if (response.status === 200) {
        MySwal.fire({
          icon: "success",
          title: "Category Updated",
          text: "The category has been successfully updated.",
        });
      }
    } catch (error) {
      console.error("Error updating category:", error);
      MySwal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error updating the category. Please try again.",
      });
    }
  };
    

return (
    <div>
       {showButton && (
                    <button
                      onClick={scrollToTop}
                      className="fixed bottom-5 right-5 p-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
                      style={{
                        background: "linear-gradient(to right, #6A5ACD, #00BFFF)", // Gradient color
                        color: "white",
                        zIndex: 1000,
                      }}
                    >
                      <FaArrowUp size={20} /> {/* FontAwesome arrow up icon */}
                    </button>
                  )}
        <h2 className="text-xl font-semibold mb-4">Existing Menu Categories</h2> 
            <div className="mb-4">
            {categories.length == 0 ? (
            <p>No categories available. Please add a category.</p>
        ) : (
          <div className="space-y-4">
          {categories.map((cat) => (
            <div key={cat._id} className="p-4 border rounded shadow-md bg-white">
              <div className="flex justify-between items-center">
                <div className="space-y-1">
                  <input
                    type="text"
                    value={cat.name}
                    onChange={(e) => handleCategoryChange(cat._id, 'name', e.target.value)}
                    className="text-lg font-bold border-b border-gray-300 focus:outline-none focus:border-blue-500"
                  />
                  <div className="flex items-center space-x-2">
                    <label className="text-sm text-gray-600">Priority:</label>
                    <input
                      type="number"
                      value={cat.priority}
                      onChange={(e) => handleCategoryChange(cat._id, 'priority', e.target.value)}
                      className="w-16 text-sm border border-gray-300 rounded px-1"
                    />
                  </div>
                  <p className="text-sm text-gray-600">
                    Visible: {cat.isVisible ? 'Yes' : 'No'}
                  </p>
                </div>
        
                <div className="flex flex-row space-x-2">
                <button
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                    onClick={() => SaveCategoryChanges(cat)}
                  >
                    Save Changes
                  </button>
                  <button
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    onClick={() => ChangeCategoryVisibility(cat._id, cat.isVisible)}
                  >
                    {cat.isVisible ? 'Hide this Menu Category' : 'Show this Menu Category'}
                  </button>
        
                  
        
                  <button
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    onClick={() => DeleteCategory(cat._id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        )}
            </div>
            <hr className="my-4" /> {/* Divider between categories */}
            <h2 className="text-xl font-semibold mt-7 mb-4">New Menu Categories</h2> 

        <form onSubmit={handleAddCategory} className="mb-6 p-4 border rounded bg-gray-50">
            <div className="mb-4">
                <label className="block   font-medium mb-1">Category Name</label> 
                <label className="text-xs text-gray-500 mb-1">e.g. Snacks, Main, Dessert, Drinks</label>
                <input
                    type="text"
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    required
                    className="w-full px-3 py-2 border rounded"
                />
            </div>
            <div className="mb-4">
                <label className="block font-medium mb-1">Priority</label>
                <label className="text-xs text-gray-500 mb-1">
                    Higher number means on the top of the list
                </label>

                <input
                    type="number"
                    value={newCategoryPriority}
                    onChange={(e) => setNewCategoryPriority(Number(e.target.value))}
                    className="w-full px-3 py-2 border rounded"
                />
            </div>
            <button
                type="submit"
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
                Add Category
            </button>
        </form>
            {loading && <p>Loading categories...</p>}

     
    </div>
);
};

export default EditCategory;
